import { type CartCommandEventData } from '@avensia/excite-commercetools/cart/command';
import { convertProductToGA4 } from 'webapp/tracking/utils';
import { ninetailedTrack } from '@avensia/excite-ninetailed';

export async function addViewItemNinetailedEvent(product: Excite.Commerce.TrackingProductInformation) {
  if (product) {
    await ninetailedTrack('view_item', {
      ...convertProductToGA4(product),
    });
  }
}

export async function removeCartNinetailedEvent(
  product: any,
  quantity: number,
  commandEventData?: CartCommandEventData,
) {
  await ninetailedTrack('remove_from_cart', {
    ...convertProductToGA4(product, commandEventData?.additionalProductAttributes),
    quantity,
  });
}

export async function addToCartNinetailedEvent(
  product: any,
  quantity: number,
  commandEventData?: CartCommandEventData,
) {
  await ninetailedTrack('add_to_cart', {
    ...convertProductToGA4(product, commandEventData?.additionalProductAttributes),
    quantity,
  });
}

export async function addPurchaseNinetailedEvent(totalOrderValue: number) {
  await ninetailedTrack('purchase', { value: totalOrderValue });
}

export async function addCheckoutNinetailedEvent(eventData: any) {
  await ninetailedTrack('begin_checkout', eventData);
}
